import { render, staticRenderFns } from "./PointsRechargeDialog.vue?vue&type=template&id=67187962&scoped=true"
import script from "./PointsRechargeDialog.vue?vue&type=script&lang=js"
export * from "./PointsRechargeDialog.vue?vue&type=script&lang=js"
import style0 from "./PointsRechargeDialog.vue?vue&type=style&index=0&id=67187962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67187962",
  null
  
)

export default component.exports